import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';

import UploadStep from '../steps/UploadStep';
import EnrollStep from '../steps/EnrollStep';
import SignalStatusStep from '../steps/SignalStatusStep';
import MetadataStep from '../steps/MetadataStep';

export default function Enroll() {
  const [step, setStep] = useState(1);
  const [ocrData, setOcrData] = useState({ serialNumber: '', eui: '' });
  const [hasEnrolled, setHasEnrolled] = useState(false);
  const [enrollSignal, setEnrollSignal] = useState(null);
  const navigate = useNavigate();
  const locationState = useLocation();
  const latLon = locationState.state?.location;

  useEffect(() => {
    if (latLon) {
      console.log(latLon);
    }
  }, [latLon]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <UploadStep
            onNext={() => setStep(2)}
            onBack={() => navigate('/')}
            setOcrData={setOcrData}
          />
        );
      case 2:
        return hasEnrolled ? (
        <EnrollStep
        ocrData={ocrData}
        onBack={() => setStep(2)}
        isAlreadyEnrolled
        signalInfo={enrollSignal}
        onContinue={() => setStep(4)}
        />
    ) : (
        <EnrollStep
        ocrData={ocrData}
        onBack={() => setStep(2)}
        onContinue={(signal) => {
            setHasEnrolled(true);
            setEnrollSignal(signal);
            setStep(4);
        }}
        />);
      case 3:
        return (
          <SignalStatusStep
            ocrData={ocrData}
            onBack={() => setStep(3)}
            onNext={() => setStep(5)}
          />
        );
      case 4:
        return (
          <MetadataStep
            onBack={() => setStep(4)}
            onNext={(finalData) => navigate('/success', {
              state: {
                ...ocrData,
                ...finalData
              }
            })}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-app text-gray-800">
      <Header location={latLon} />
      <main className="max-w-xl mx-auto px-4 py-10">
        <div className="bg-white rounded-xl shadow p-6">
          <div className="mb-6">
            <div className="text-sm text-gray-600 mb-1">Step {step} of 5</div>
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-primary transition-all duration-300" style={{ width: `${(step / 5) * 100}%` }} />
            </div>
          </div>
          {renderStep()}
        </div>
      </main>
    </div>
  );
}
